<template>
  <div>
    <div id="enterprise-map" v-if="enterpriseInfo.base">
      <!-- 企业图谱 -->
      <div class="enterprise-map-type">
        <!-- 企业图谱 -->
        <div class="enterprise-map-item" id="企业图谱">
          <div class="enterprise-map-item-title">企业图谱</div>
          <div class="enterprise-map-item-value">
            <div class="chart">
              <div id="chart1" style="width: 100%; height: 100%"></div>
            </div>
          </div>
        </div>
        <!-- 股权穿透图 -->
        <div class="enterprise-map-item" id="股权穿透图">
          <div class="enterprise-map-item-title">股权穿透图</div>
          <div class="enterprise-map-item-value">
            <div class="chart">
              <div id="chart2" style="width: 100%; height: 100%"></div>
            </div>
          </div>
        </div>
        <!-- 实际控制人 -->
        <div class="enterprise-map-item" id="实际控制人">
          <div class="enterprise-map-item-title">实际控制人</div>
          <div class="enterprise-map-item-value">
            <div class="chart">
              <div id="chart3" style="width: 100%; height: 100%"></div>
            </div>
          </div>
        </div>
        <!-- 最终受益人 -->
        <div class="enterprise-map-item" id="最终受益人">
          <div class="enterprise-map-item-title">最终受益人</div>
          <div class="enterprise-map-item-value">
            <div class="chart">
              <div id="chart4" style="width: 100%; height: 100%"></div>
            </div>
          </div>
        </div>
        <!-- 关联图谱 -->
        <div class="enterprise-map-item" id="关联图谱">
          <div class="enterprise-map-item-title">关联图谱</div>
          <div class="enterprise-map-item-value">
            <div class="chart"></div>
          </div>
        </div>
      </div>
      <div id="my-dialog" v-if="dialogData.flag">
        <my_dialog
          :width="dialogData.width"
          :title="dialogData.title"
          :buttonArray="dialogData.buttonArray"
          :data="dialogData.data"
          @colseDialog="colseDialog"
          @dialogOper="drawerOper"
          @buttonOper="drawerOper"
        ></my_dialog>
      </div>
    </div>
    <div v-else>
      <el-empty description="暂无数据"></el-empty>
    </div>
  </div>
</template>

<script>
import { callWithDelay } from "@/minixs.js";
const baseLabel = {
  fontSize: 14,
  lineHeight: 21,
  borderWidth: 1,
  padding: 8,
  borderRadius: 5,
  align: "center",
  overflow: "breakAll",
  backgroundColor: "#ECF5FF",
  borderColor: "#409EFF",
};

const lineLabel = {
  fontSize: 14,
  color: "#409EFF",
};

const baseLabel2 = {
  fontSize: 14,
  //   lineHeight: 21,
  padding: 30,
  borderRadius: 100,
  align: "center",
  overflow: "breakAll",
  backgroundColor: "#F84363",
  color: "#fff",
  borderColor: "#F84363",
};
export default {
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    tabActive: {
      type: Object,
      default: () => {},
    },
    enterpriseInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    my_dialog: () => import("@/components/dialog.vue"),
  },
  data() {
    return {
      baseInfo: {},
      dialogData: {
        flag: false,
        width: "45%",
        title: "新建报销",
        buttonArray: [
          {
            text: "提交",
            active: "submit_gnjinjilu",
          },
        ],
        data: [],
      },
      enterpriseMap: {},
      chart1Data: {
        name: "",
        children: [
          {
            name: "对外投资",
            children: [],
          },
          {
            name: "分支机构",
            children: [],
          },
          {
            name: "历史法人",
            children: [],
          },
          {
            name: "股东",
            children: [],
          },
          {
            name: "高管",
            children: [],
          },
          {
            name: "历史股东",
            children: [],
          },
        ],
      },
      chart1: null,
      chart2Data: {},
      chart2: null,
      chart3Data: {},
      chart3: null,
      chart4Data: {},
      chart4: null,
    };
  },
  mixins: [callWithDelay],
  watch: {
    "tabActive.tab2Active": {
      handler(newValue, oldValue) {
        // tabActive.tab3Active 变化时 页面滑动到对应区域
        this.$nextTick(() => {
          document
            .getElementById(newValue)
            .scrollIntoView({ behavior: "smooth" });
        });
      },
    },
  },
  methods: {
    // 企业图谱
    getEnterpriseMap() {
      this.$request(
        "get",
        "/xiaoLanBen/api_4720?eid=" + this.enterpriseInfo.base.eid,
        {},
        (data) => {
          this.enterpriseMap = data.entInfo.enterpriseMap;
          this.chart1Data.name = this.enterpriseInfo.base.entname || "";
          this.chart1Data.children.forEach((item) => {
            if (item.name == "对外投资") {
              item.children = this.enterpriseMap.investments.map((item) => {
                return {
                  name: item.investmentCompany,
                  eid: item.investmentEid,
                };
              });
            }
            if (item.name == "分支机构") {
              item.children = this.enterpriseMap.branches.map((item) => {
                return {
                  name: item.companyName,
                  eid: item.eid,
                };
              });
            }
            if (item.name == "历史法人") {
              item.children = this.enterpriseMap.hisLegalPersons.map((item) => {
                return {
                  name: item.name,
                  eid: item.pid,
                };
              });
            }
            if (item.name == "股东") {
              item.children = this.enterpriseMap.shareholders.map((item) => {
                return {
                  name: item.name,
                  eid: "",
                };
              });
            }
            if (item.name == "高管") {
              item.children = this.enterpriseMap.priPersons.map((item) => {
                return {
                  name: item.name,
                  eid: "",
                };
              });
            }
            if (item.name == "历史股东") {
              item.children = this.enterpriseMap.hisShareholders.map((item) => {
                return {
                  name: item.name,
                  eid: "",
                };
              });
            }
          });

          this.chart1 = this.$echarts.init(document.getElementById("chart1"));
          this.chart1.setOption({
            tooltip: {
              trigger: "item",
              triggerOn: "mousemove",
            },
            series: [
              {
                type: "tree",
                id: 0,
                name: "tree1",
                data: [this.chart1Data],
                roam: true, // 开启平移和缩放
                top: "10%",
                left: "20%",
                bottom: "22%",
                right: "20%",
                width: "50%",
                symbolSize: 7,
                edgeShape: "polyline",
                edgeForkPosition: "63%",

                lineStyle: {
                  width: 2,
                },
                label: {
                  backgroundColor: "#ECF5FF",
                  position: "left",
                  verticalAlign: "middle",
                  align: "right",
                  padding: [8, 8, 8, 8],
                  minMargin: 80,
                  borderRadius: 5,
                  borderColor: "#409EFF",
                  borderWidth: 1,
                },
                leaves: {
                  label: {
                    position: "right",
                    verticalAlign: "middle",
                    align: "left",
                    padding: [8, 8, 8, 8],
                    borderRadius: 5,
                    borderColor: "#409EFF",
                    borderWidth: 1,
                  },
                },
                emphasis: {
                  focus: "descendant",
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
            toolbox: {
              show: true,
              feature: {
                saveAsImage: {
                  show: true,
                  pixelRatio: 2, // 设置图片分辨率
                },
                myFull: {
                  show: true,
                  title: "全屏查看",
                  icon: "path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891",
                  onclick: (e) => {
                    const element = document.getElementById("chart1");
                    if (element.requestFullScreen) {
                      element.requestFullScreen();
                    } else if (element.msRequestFullscreen) {
                      element.msRequestFullScreen();
                    } else if (element.webkitRequestFullScreen) {
                      element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                      element.mozRequestFullScreen();
                    }
                  },
                },
              },
            },
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 股权穿透图
    getEquityInformation() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid, // 企业eid
        investment: true, // 投资
        shareholder: true, // 股东
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_4719",
        requestData,
        (data) => {
          if (data.entInfo.equityThrough.investment.detailList.length > 0) {
            this.chart2Data = {
              name: data.entInfo.equityThrough.investment.name,
              label: baseLabel,
              children: data.entInfo.equityThrough.investment.detailList.map(
                (item) => {
                  return {
                    name: item.fundedRatio,
                    label: lineLabel,
                    symbol: "none",
                    children: [
                      {
                        name: item.name,
                        label: baseLabel,
                        symbolSize: 0.1, // 兼容echarts4
                      },
                    ],
                  };
                },
              ),
            };
          }
          this.chart2 = this.$echarts.init(document.getElementById("chart2"));
          this.chart2.setOption({
            tooltip: {
              trigger: "item",
              triggerOn: "mousemove",
            },
            series: [
              {
                type: "tree",
                id: 0,
                name: "tree1",
                data: [this.chart2Data],
                roam: true, // 开启平移和缩放
                top: "20%",
                left: "20%",
                bottom: "22%",
                right: "20%",
                symbolSize: 7,
                edgeShape: "curve",
                edgeForkPosition: "63%",
                initialTreeDepth: 2,
                orient: "TB", // 渲染朝向, 从上到下
                symbolRotate: -90, // 箭头顺时针旋转90度
                itemStyle: { color: "#ddd", borderWidth: 0 },
                lineStyle: { color: "#ddd", curveness: 0.5 },
                lineStyle: {
                  width: 3,
                },
                label: {
                  position: "center",
                  verticalAlign: "middle",
                  align: "center",
                  width: 150,
                  overflow: "truncate",
                },
                leaves: {
                  label: {
                    position: "center",
                    verticalAlign: "middle",
                    align: "center",
                  },
                },
                emphasis: {
                  focus: "descendant",
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
            toolbox: {
              show: true,
              feature: {
                saveAsImage: {
                  show: true,
                  pixelRatio: 2, // 设置图片分辨率
                },
                myFull: {
                  show: true,
                  title: "全屏查看",
                  icon: "path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891",
                  onclick: (e) => {
                    const element = document.getElementById("chart2");
                    if (element.requestFullScreen) {
                      element.requestFullScreen();
                    } else if (element.msRequestFullscreen) {
                      element.msRequestFullScreen();
                    } else if (element.webkitRequestFullScreen) {
                      element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                      element.mozRequestFullScreen();
                    }
                  },
                },
              },
            },
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 实际控制人
    getNewRealHold() {
      this.$request(
        "get",
        "/xiaoLanBen/api_4712?eid=" + this.enterpriseInfo.base.eid,
        {},
        (data) => {
          this.chart3Data = {
            name: data.entInfo.newRealHold.name,
            label: baseLabel2,
            children: [
              {
                name: data.entInfo.newRealHold.rate * 100 + "%",
                label: lineLabel,
                symbol: "none",
                children: [
                  {
                    name: data.entInfo.newRealHold.entName,
                    label: baseLabel,
                  },
                ],
              },
            ],
          };

          this.chart3 = this.$echarts.init(document.getElementById("chart3"));
          this.chart3.setOption({
            tooltip: {
              trigger: "item",
              triggerOn: "mousemove",
            },
            series: [
              {
                type: "tree",
                id: 0,
                name: "tree1",
                data: [this.chart3Data],
                roam: true, // 开启平移和缩放
                top: "20%",
                left: "20%",
                bottom: "22%",
                right: "20%",
                symbolSize: 7,
                edgeShape: "curve",
                edgeForkPosition: "63%",
                initialTreeDepth: 2,
                orient: "TB", // 渲染朝向, 从上到下
                symbolRotate: -90, // 箭头顺时针旋转90度
                itemStyle: { color: "#ddd", borderWidth: 0 },
                lineStyle: { color: "#ddd", curveness: 0.5 },
                lineStyle: {
                  width: 3,
                },
                label: {
                  position: "center",
                  verticalAlign: "middle",
                  align: "center",
                },
                leaves: {
                  label: {
                    position: "center",
                    verticalAlign: "middle",
                    align: "center",
                  },
                },
                emphasis: {
                  focus: "descendant",
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
            toolbox: {
              show: true,
              feature: {
                saveAsImage: {
                  show: true,
                  pixelRatio: 2, // 设置图片分辨率
                },
                myFull: {
                  show: true,
                  title: "全屏查看",
                  icon: "path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891",
                  onclick: (e) => {
                    const element = document.getElementById("chart2");
                    if (element.requestFullScreen) {
                      element.requestFullScreen();
                    } else if (element.msRequestFullscreen) {
                      element.msRequestFullScreen();
                    } else if (element.webkitRequestFullScreen) {
                      element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                      element.mozRequestFullScreen();
                    }
                  },
                },
              },
            },
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 最终受益人
    getFinalBeneficiary() {
      this.$request(
        "get",
        "/xiaoLanBen/api_4711?eid=" + this.enterpriseInfo.base.eid,
        {},
        (data) => {
          if (data.entInfo.newFinalBeneficiary.length > 0) {
            this.chart4Data = {
              name: data.entInfo.newFinalBeneficiary[0].name,
              label: baseLabel2,
              children: [
                {
                  name: data.entInfo.newFinalBeneficiary[0].rate * 100 + "%",
                  label: lineLabel,
                  symbol: "none",
                  children: [
                    {
                      name: data.entInfo.newFinalBeneficiary[0].entName,
                      label: baseLabel,
                    },
                  ],
                },
              ],
            };
          }

          this.chart4 = this.$echarts.init(document.getElementById("chart4"));
          this.chart4.setOption({
            tooltip: {
              trigger: "item",
              triggerOn: "mousemove",
            },
            series: [
              {
                type: "tree",
                id: 0,
                name: "tree1",
                data: [this.chart4Data],
                roam: true, // 开启平移和缩放
                top: "20%",
                left: "20%",
                bottom: "22%",
                right: "20%",
                symbolSize: 7,
                edgeShape: "curve",
                edgeForkPosition: "63%",
                initialTreeDepth: 2,
                orient: "TB", // 渲染朝向, 从上到下
                symbolRotate: -90, // 箭头顺时针旋转90度
                itemStyle: { color: "#ddd", borderWidth: 0 },
                lineStyle: { color: "#ddd", curveness: 0.5 },
                lineStyle: {
                  width: 3,
                },
                label: {
                  position: "center",
                  verticalAlign: "middle",
                  align: "center",
                },
                leaves: {
                  label: {
                    position: "center",
                    verticalAlign: "middle",
                    align: "center",
                  },
                },
                emphasis: {
                  focus: "descendant",
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
            toolbox: {
              show: true,
              feature: {
                saveAsImage: {
                  show: true,
                  pixelRatio: 2, // 设置图片分辨率
                },
                myFull: {
                  show: true,
                  title: "全屏查看",
                  icon: "path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891",
                  onclick: (e) => {
                    const element = document.getElementById("chart2");
                    if (element.requestFullScreen) {
                      element.requestFullScreen();
                    } else if (element.msRequestFullscreen) {
                      element.msRequestFullScreen();
                    } else if (element.webkitRequestFullScreen) {
                      element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                      element.mozRequestFullScreen();
                    }
                  },
                },
              },
            },
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },

    /**
     * 选择页码事件
     * val:当前页
     */
    handleCurrentChange(table) {
      this.companyContactInformation.pageData = table.pageData;
      this.getCompanyContactInformation();
    },
    drawerOper(active) {
      let requestData = {};
      switch (active) {
        case "makesure_add_contact":
          this.getContactList();

          break;
        case "cancel":
          this.dialogData.flag = false;
          break;
        default:
          break;
      }
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  mounted() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    console.log("tabActive", this.tabActive);
    if (this.enterpriseInfo.base && this.enterpriseInfo.base.eid) {
      this.callWithDelay(
        [
          this.getEnterpriseMap,
          this.getEquityInformation,
          this.getNewRealHold,
          this.getFinalBeneficiary,
        ],
        300,
      );
    }
  },
};
</script>

<style lang="less">
#enterprise-map {
  width: 100%;
  background-color: #fff;
  .enterprise-map-type {
    width: 100%;
    .enterprise-map-item {
      width: 100%;
      margin-top: 32px;
      scroll-margin-top: 180px;
      &:first-child {
        margin-top: 0;
      }
      /deep/ .el-input__inner {
        width: auto !important;
        border: 1px solid #dcdfe6;
      }
      .enterprise-map-item-title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
      }
      .enterprise-map-item-tag {
        display: flex;
        margin: 12px 0;
        .tag {
          font-size: 14px;
          color: #777e95;
          cursor: pointer;
          height: 28px;
          padding: 0 12px;
          line-height: 28px;
          cursor: pointer;
          border-radius: 14px;
        }
        .is-active {
          color: #327bf9;
          background: #eaf2ff;
        }
        .is-disabled {
          color: #c3c8da;
          cursor: not-allowed;
        }
      }
      .enterprise-map-item-value {
        width: 100%;
        .chart {
          width: 100%;
          height: 523px;
          border: 1px solid #eff1f8;
        }
      }
    }
  }
}
</style>
